import React, { useState, useEffect } from 'react';
import { DataTable, PageWrapper } from '../../components';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../../shared/enums';
import { useTranslation } from 'react-i18next';
import { getVehicleTypeList } from '../../api/vehicle-type';
import { RiAddLargeLine } from 'react-icons/ri';
import Button from '../../components/common/Button';

const VehicleType = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    // const [filter, setFilter] = useState({});
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
    const [totalPages, setTotalPage] = useState(0);
    const [data, setData] = useState([]);

    const columns = [
        { key: "name", label: t("NAME"), },
        {
            key: "action", label: t("ACTION"), render: (v, data) => <Dropdown>
                <Dropdown.Toggle variant="primary" size="sm" className='py-0'></Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigate(Pages.VehicleTypeDetail.replace(":id", data.id))}>{t("EDIT")}</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        }
    ]

    const filters = [
        { type: "input", label: t("SEARCH"), name: "search" },
        { type: "select", label: t("SUSPENDED"), name: "suspended", options: [{ label: "Yes", value: true }, { label: "No", value: false }] }
    ]

    useEffect(() => {
        getData(pagination)
    }, [pagination])

    // useEffect(() => {
    //     getData(pagination, filter)
    // }, [pagination, filter])

    const getData = async (pagination, filter) => {
        // const response = await getAdminList({ skip: (pagination?.page - 1) * pagination?.pageSize, limit: pagination?.pageSize, ...filter })
        const response = await getVehicleTypeList({ skip: (pagination?.page - 1) * pagination?.pageSize, limit: pagination?.pageSize })
        setData(response.items)
        setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize))
    }

    return (
        <PageWrapper
            headerProps={{
                title: "VEHICLE_TYPE",
                rightElement: <Button icon={<RiAddLargeLine />} onClick={() => navigate(Pages.VehicleTypeDetail.replace(":id", "new"))}>{t("ADD")}</Button>
            }}
        >
            {/* <Filter filters={filters} onChangeFilter={setFilter} /> */}
            <DataTable columns={columns} data={data} pagination={{ ...pagination, totalPages, onChange: setPagination }} />
        </PageWrapper>
    );
};

export default VehicleType;
